export default __webpack_public_path__ + "static/media/login@2x.ec8601c0.png";